import React, { useEffect, useState } from "react";
import "./BannerImage.scss";
import "./Responsive.scss";
import Skeleton from "react-loading-skeleton";
import { Config } from "../../Config";

const BannerImage = ({ data, banner, secondPart }) => {
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    let width = window.innerWidth;
    if (banner) {
      if (width <= 500) {
        setPhotos(data?.mobileImage ?? []);
      } else if (width > 500 && width <= 992) {
        setPhotos(data?.tabletImage ?? []);
      } else {
        setPhotos(data?.desktopImage ?? []);
      }
    } else {
      if (width <= 500) {
        setPhotos(data?.mobile ?? []);
      } else if (width > 500 && width <= 992) {
        setPhotos(data?.tablet ?? []);
      } else {
        setPhotos(data?.desktop ?? []);
      }
    }
  }, [data]);
  return (
    <>
      {data.mobile != undefined || photos.length > 0 ? (
        <div className="bannerImageWrapper">
          {!banner ? (
            <div className="imageWrapper">
              {photos.length > 0 &&
                photos.map((item, index) => {
                  return <img src={item.image} key={index} alt={item.link} className="bannerImageItem" />;
                })}
            </div>
          ) : (
            <div className="imageWrapper">
              {photos.length > 0 && <img src={photos} alt="banner" className="bannerImageItem" />}
            </div>
          )}
        </div>
      ) : (
        <>
          <Skeleton
            highlightColor={Config.skeletonHighlightColor}
            containerClassName="productsSkeletonWrapper"
            className="sliderImageFigure"
            count={1}
          />
          {secondPart && (
            <Skeleton
              highlightColor={Config.skeletonHighlightColor}
              containerClassName="productsSkeletonWrapper"
              className="productsSkeletonItemm skeleton"
              count={2}
            />
          )}
        </>
      )}
    </>
  );
};

export default React.memo(BannerImage);
